import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  Divider,
} from '@mui/material';

const TransactionCard = ({ transaction }) => (
  <Box
    sx={{
      p: 2,

      backgroundColor: '#f9f9f9',
      '&:hover': { boxShadow: 4, backgroundColor: '#fff' },
    }}
  >
    <Typography sx={{ fontSize: 16, fontWeight: '600' }}>
      Date: {transaction.date}
    </Typography>
    <Typography sx={{ fontSize: 14, fontWeight: '500' }}>
      Sales: {transaction.prefix_uom}
      {transaction.sales} {transaction.suffix_uom}
    </Typography>
  </Box>
);

const LastTransactions = ({
  section_header_display_title,
  transactions = [],
}) => (
  <Card sx={{ p: 2 }}>
    <Grid sx={{ width: '100%' }}>
      <Typography sx={{ fontSize: 20, fontWeight: 'bold', mb: 4 }}>
        {section_header_display_title}
      </Typography>
      <Grid
        container
        spacing={2}
      >
        {transactions.map((transaction, index) => (
          <Grid
            item
            xs={12}
            sm={4}
            md={2}
            key={index}
          >
            <TransactionCard transaction={transaction} />
          </Grid>
        ))}
      </Grid>
    </Grid>
  </Card>
);

export default LastTransactions;
